import React, { Component } from 'react';
import {
  Router as ReactRouter,
  Route,
  Redirect,
  browserHistory,
} from 'react-router';
import { URL_PREFIX } from '../const/forms';

import FormPage from '../containers/FormPage';
import MainPage from '../containers/MainPage/Index';
import Auth from '../containers/Auth';

export const history = browserHistory;

const formKindMap = {
  investors: 24,
  expertise: 0,
  requests: undefined,
  undefined: 0,
  '': 0,
};

const getFormKindId = () => {
  const pathNamesArray = history.getCurrentLocation().pathname.split('/');
  const angelsIndex = pathNamesArray.indexOf('angels');

  const formType = pathNamesArray[angelsIndex + 1];

  return formKindMap[formType];
};

const formKind = getFormKindId();

class Router extends Component {
  render = () => (
    <Auth formKind={formKind}>
      <ReactRouter history={history}>
        <Redirect from="/" to={URL_PREFIX + '/'} />
        <Route
          exact
          path={URL_PREFIX + '/forms/:form_type/:process_id'}
          component={FormPage}
        />
        {/* <Route exact path={URL_PREFIX + /company'} component={SelectCompany}/> */}

        <Route exact path={URL_PREFIX + '/'} component={MainPage} />
        <Route exact path={URL_PREFIX + '/:type/'} component={MainPage} />

        <Route
          exact
          path={URL_PREFIX + '/404'}
          component={() => <p>ERROR 404: Route not found</p>}
        />
        <Redirect from="*" to={URL_PREFIX + '/404'} />
      </ReactRouter>
    </Auth>
  );
}

export default Router;
